
<VariableAssignmentMenu
  v-if="request"
  :key="requestKey"
  ref="menu"
  :variableId="variableId"
  :variableName="request.variableName"
  :spaceId="currentSpaceId"
  :saving="saving"
  :pendingUserId="pendingUserId"
  @onAssignUser="onAssignUser"
  @onDeleteRecipient="onDeleteRecipient"
/>
